export const FormatEnum = {
  EXCEL: "EXCEL",
  PDF: "PDF",
  KML: "KML",
};
